<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        v-if="!_.isEmpty(services)"
        md12
      >
        <h2>{{ $t('packs.myProducts') }}</h2>
        <v-card class="services">
          <v-data-table
            class="text-no-wrap" 
            :headers="headers"
            :items="services"
            :hide-default-footer="true"
            :mobile-breakpoint="900"
            :items-per-page="200"
          >
            <template v-slot:header.activated_till="{ }">
              <span>{{ $t('packs.activatedTill') }}</span>
            </template>  
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                v-text="header.text"
              />
            </template>
            <template v-slot:item.name="{ item }">
              <b>{{ item.name }}</b>
            </template>
            <template v-slot:item.config="{ item }">
              <span 
                v-if="item.config"
              >
                {{ $t('packs.connections') }}: <b>{{ item.config.linkings == 0 ? $t('packs.unlimited') : item.config.linkings }}</b><br>
              </span>
              <span v-else>-</span>  
            </template>
            <template v-slot:item.status="{ item }">
              <b 
                :class="colorStatus(item.status)"
              >
                {{ $t('globals.'+item.status) }} 
              </b>
            </template>
            <template v-slot:item.activated_till="{ item }">
              {{ item.activated_till == null ? '--' : item.activated_till | moment('L') }}
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-else
        md5
        xs12
        new-record
      >
        <v-row>
          <v-col cols="12">
            <v-row
              justify="center"
              align="center"
            >
              <v-col>
                <v-card
                  style="padding:50px"
                >
                  <component
                    :is="newIcon"
                    style="margin-bottom:20px;"
                  />
                  <h3>{{ $t('packs.myProducts') }}</h3>
                  <p>{{ $t('packs.notFoundDesc') }}</p>
                </v-card> 
              </v-col>
            </v-row>  
          </v-col>
        </v-row>    
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

const SERVICES_QUERY = require('@/graphql/queries/Services.gql');
import IconProduct from '@/components/icons/IconProduct.vue'


export default {
  name: 'Services',
  data() {
    return {
      newIcon: IconProduct,
      loading: false,
      services: [],
      headers: [
        {
          sortable: false,
          text: this.$t('packs.name'),
          value: 'name'
        },
        // {
        //   sortable: false,
        //   text: this.$t('packs.options'),
        //   value: 'config',
        // },
        {
          sortable: false,
          text: this.$t('globals.status'),
          value: 'status',
        },
        {
          sortable: false,
          text: this.$t('packs.activatedTill'),
          value: 'activated_till',
        }
      ]
    }
  },
  methods: {
  },
  apollo: {
    services: {
      query: SERVICES_QUERY,
    }
  }
}
</script>
<style lang="scss">
.services
{
  th {
    .v-icon {
      margin-left:4px;
      font-size: 16px;
    }
  }
  td {
    padding: 15px;
  }
}
 
</style>
